export default theme => ({
    listItem: {
        fontSize: 14,
        letterSpacing: '0.024em',
        lineHeight: '2',
        marginBottom: 24,
        '& a': {
            color: theme.palette.primary.main,
            '&:hover, &:focus': {
                color: theme.palette.primary.dark,
            }
        }
    },
})